export { ApplicantInformationSection as default } from './ApplicantInformationSection';
